// utils/focusUtils.js
export const focusOnFirstError = (errors, inputRefs) => {
  const firstErrorField = Object.keys(errors)[0];
  if (firstErrorField && inputRefs[firstErrorField]?.current) {
    inputRefs[firstErrorField].current.focus();
  }
};
